<template>
<div class="drawerWrap templateDrawer">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-width="120px">
      <el-form-item label="模板名称" prop="templateName">
        <el-input v-model="form.templateName" minlength="1" maxlength="20" :disabled="handleType=='edit'?true:false" placeholder="请输入模板名称"></el-input>
      </el-form-item>
      <el-form-item label="巡检点" prop="pointName">
        <el-select v-model="pointName" placeholder="请选择巡检点"  @change="selectChange">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="巡检类型" prop="typeIds" v-if="pointName">
        <el-select v-model="typeIds" placeholder="请选巡检类型" @change="typeChange">
          <el-option v-for="item in options1" :key="item.typeId" :label="item.typeName" :value="item.typeId"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="巡检内容" prop="" v-if="typeIds" class="listCons">
        <el-checkbox-group v-model="form.content"  @change="checkSelect">
          <el-checkbox v-for="(item,index) in checkList" :label="item.id" :key="index" >{{item.content}}</el-checkbox>
        </el-checkbox-group>
        <div class="list">
          <ul>
            <li v-for="(item,index) in checkList" :label="item.id" :key="index">
              <div class="item">
                <span>{{item.content}}</span>
              </div>
            </li>
          </ul>
        </div>
      </el-form-item> -->
      <el-form-item>
        <div class="saveBtn">
          <el-button @click="saveCons" type="primary">添加</el-button>
        </div>
      </el-form-item>
      <!-- <el-form-item label="" prop=""> -->
      <div class="tableData">
        <!-- <el-button size="small" @click="delLevel" class="del" style="margin-left:20px;">删除</el-button> -->
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;padding-left:20px;" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="模板名称" width="120">
            <template slot-scope="scope">{{ scope.row.templateName }}</template>
          </el-table-column>
          <el-table-column prop="pointName" label="巡检点" show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- <span v-for="(item,index) in scope.row.pointView" :key="index">
                  <span>{{item}}</span><span>{{(index+1)==scope.row.pointView.length?'':','}}</span>
                  </span> -->
              <span>{{scope.row.pointName}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="巡检设备类型">
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.contents" :key="index">
                  <span>{{item.typeName}}</span><span>{{(index+1)==scope.row.contents.length?'':','}}</span>
			  </span>
              <!-- <span>{{scope.row.typeName}}</span> -->
            </template>
          </el-table-column>
<!--          <el-table-column prop="address" label="巡检内容" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.contents" :key="index">
                <span>{{item.content}}</span><span>{{(index+1)==scope.row.contents.length?'':','}}</span>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="操作" width="170">
              <template slot-scope="scope">
                <span @click="delLevel(scope.row)" class="dele">删除</span>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- </el-form-item> -->
    </el-form>
  </div>
  <div class="drawerFoot">
    <!-- <el-button type="primary" @click="confirmHandle()">完成</el-button> -->
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    templateId: {
      type: String,
      default: ""
    },
    templateName: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: {}
    },
    handleType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      checkList: [],
      multipleSelection: [],
      tableData: [],
      form: {
        templateName: "",
        templateId: "",
        pointDtoList: []
      },
      formRules: {
        templateName: [{
          required: true,
          validator: this.validateTemplateName,
          trigger: "blur"
        }]
      },
      flag: false,
      isHave: true,
      options: [],
      pointName: null,
      options1: [],
      typeIds: null,
      dataList: [],
      change:false,
      setPointName:null,
    };
  },
  created() {
    this.getPointName()
  },
  mounted() {
    this.init();
  },
  methods: {
    checkSelect(val) {
      console.log(val);

    },
    handleSelectionChange(val) {
      console.log(val);

      this.multipleSelection = val;
    },
    /**
     * 页面数据校验
     */
    validateTemplateName(rule, value, callback) {
      if (value === "") {
        callback(new Error("模板名称不能为空"));
      } else if (value.length > 20) {
        callback(new Error("模板名称长度不能超过20个字符"));
      } else {
        callback()
      }
    },
    /**
     * 页面初始化
     */
    init() {
      if (this.handleType == 'add') {
        this.form.templateName = ''
      } else if (this.handleType == "edit") {
        this.form.templateName = this.editData.templateName
        this.form.templateId = this.editData.templateId
        let arry=[]
        arry = this.editData.pointInfo
        arry.forEach(item => {
          item.typeName = item.pointTypeName
          item.templateName = this.form.templateName
          item.templateId = this.form.templateId
          this.request.get("/front/polling/template/getTypeInfo", {
            "tenantId": "123456",
            "pointId": item.pointId
          }).then(res => {
            console.log(res);
            if (res.code == 200&&res.data.length) {
              item.contents = res.data
              this.tableData=[...arry]              
            }
          }).catch(error => console.log(error));
        })
        console.log(arry);
        console.log(this.tableData);  
      }
    },

    /**
     * 取消
     */
    cancelHandle() {
      this.$emit("cancel", false);
    },
    /**
     * 确认
     */
    confirmHandle() {
      this.$emit("confirm", true);
    },
    saveCons() {
      console.log(this.pointName);
      console.log(this.typeIds);
      console.log(this.checkList);
      console.log(this.options);
      
      this.dataList=[]
      this.form.pointDtoList=[]
      if (this.form.templateName == '') {
        this.msg.warn('请填写模板名称')
        return
      }
      if(!this.pointName){
        this.msg.warn('请选择巡检点')
        return 
      }
      // if(!this.typeIds){
      //   this.msg.warn('请选择巡检设备类型')
      //   return 
      // }
      let pointId = null
      let typeName = null
      this.options.forEach(item => {
        if (item.id==this.pointName) {
          pointId = item.id
          this.setPointName=item.name          
	    }
      })
      this.options1.forEach(item => {
        if (item.typeId == this.typeIds) {
          typeName = item.typeName
        }
      })
      this.dataList.push({
        pointId: pointId,
        templateName: this.form.templateName,
        pointName: this.setPointName,
        typeName: typeName,
        contents: this.checkList
      })
      if (this.dataList.length > 1) {
        this.dataList.forEach((items, index) => {
          for (var j = index + 1; j < this.dataList.length; j++) {
            // this.dataList[index].typeName == this.dataList[j].typeName &&
            if ( this.dataList[index].pointId == this.dataList[j].pointId) { //第一个等同于第二个，splice方法删除第二个
              this.dataList.splice(j, 1);
              j--;
              // this.msg.warn("巡检点已存在")
            }
          }
        })
      }
      console.log(this.dataList);
      this.dataList.forEach(item => {
        this.form.pointDtoList.push({
          "pointId": item.pointId,
          // "serial":50
        })
      })
      this.form.pointDtoList.forEach((items, index) => {
        for (var j = index + 1; j < this.form.pointDtoList.length; j++) {
          if (this.form.pointDtoList[index].pointId == this.form.pointDtoList[j].pointId) { //第一个等同于第二个，splice方法删除第二个
            this.form.pointDtoList.splice(j, 1);
            j--;
          }
        }
      })
      console.log(this.tableData);
      
      if (this.handleType == 'add') {
        this.tableData = [...this.dataList]
      } else {
        this.change = true
        // this.form.pointDtoList=[]
        this.dataList.forEach(item=>{
          this.tableData.push(item)        
        })
        this.tableData.forEach((items, index) => {
          for (var j = index + 1; j < this.tableData.length; j++) {
            // this.tableData[index].typeName == this.tableData[j].typeName && 
            if (this.tableData[index].pointId == this.tableData[j].pointId) { //第一个等同于第二个，splice方法删除第二个
              this.tableData.splice(j, 1);
              j--;
              // this.msg.error("巡检点已存在")
            }
          }
        })
        console.log(this.tableData);
      }
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        delete this.form.templateId
        this.$emit("confirm", this.form);
        this.$emit("update:loading", true);
      })
    },
    delLevel(data) {
      console.log(data);
      this.delClick(data)
    },
    //删除
    delClick(data) {
      let params = {
        templateId: this.form.templateId,
        pointId: data.pointId
      }
      //删除
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.postParamsData("/front/polling/template/delTemplateForPointId", params).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.tableData.forEach((items,indexs)=>{
                if(this.tableData[indexs].pointId==data.pointId){
                    this.tableData.splice(indexs, 1);
                  }
                })
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getPointName() { //获取巡检模板下拉列表显示巡检点信息1
      this.request.get("/front/polling/template/getPointName", {
        "tenantId": "123456"
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.options = res.data

        }
      }).catch(error => console.log(error));
    },
    selectChange(data) { //获取巡检模板下拉列表显示巡检类型信息2
      this.request.get("/front/polling/template/getTypeInfo", {
        "tenantId": "123456",
        "pointId": data
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.options1 = res.data
          this.typeIds = null
        }
      }).catch(error => console.log(error));
    },
    // typeChange(data) { //GET /front/polling/template/getItemInfo获取巡检模板下拉列表显示巡检项信息3
    //   this.request.get("/front/polling/template/getItemInfo", {
    //     "tenantId": "123456",
    //     "typeId": data
    //   }).then(res => {
    //     console.log(res);
    //     if (res.code == 200) {
    //       this.checkList = res.data
    //     }
    //   }).catch(error => console.log(error));
    // },
  }
};
</script>

<style lang="scss" scoped>
.drawerWrap {
  font-size: 0;

  .tableData {
    border-top: 1px solid #eee;

    .del {
      margin-top: 15px;
      border-radius: 5px;
      color: #fff;
      background: #FF5722;

      &:hover {
        color: #fff;
        background: red;
      }
    }
    .dele {
      padding: 5px 12px;
      cursor: pointer;
      border-radius: 5px;
      color: #fff;
      background: #FF5722;
      border: none;
      &:hover {
        color: #fff;
        background: red;
      }
    }
  }

  .listCons {
    .list {
      ul {
        li {
          .item {
            span {
              color: #6e6e6e;
              font-size: 14px;
              font-weight: 300;
            }
          }
        }
      }
    }
  }
}
</style><style lang="scss">
.templateDrawer {
  .el-form {
    .listCons {
      .el-form-item__content {
        line-height: 30px !important;
      }
    }
  }

  .el-table th>.cell {
    color: #6e6e6e;
    font-size: 14px;
    font-weight: 600;
  }

  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;

      .el-checkbox {
        height: 20px;
        line-height: 20px !important;
        width: 100%;

        .el-checkbox__label {
          width: 100%;
        }
      }
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }
}
</style>
